import StatsComponent from './Stats.vue';

export const statsRoutes = {
  path: '/stats',
  name: 'Stats',
  component: StatsComponent,
  meta: {
    title: 'Stats',
    requireAuth: true
  }
};
